export default __webpack_public_path__ + "static/30-2f62650595ecc7940b5646db5013e6c0.png";